import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IGoalTable0, IAuthReduxProps, ITarget } from '../../types/interfaces';

import GoalEdit from './GoalEdit0';
import BudgetEdit from './BudgetEdit0';
import TableContainer from "../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faCommentDots, faEdit, faExclamationTriangle, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants'
import { PRIVILEGE } from '../../types/privileges';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';

const GoalTable = ({ 
  linesData,
  societeValue,
  goals,
  goal_societe_defaults,
  budgets,
  showUsers,
  setShowUsers,
  auth
 }: IGoalTable0) => {
  const [goalsEditModal, setGoalsEditModal] = useState(false);
  const [goalsEditMonth, setGoalsEditMonth] = useState<any>(undefined);
  const [goalsEditUser, setGoalsEditUser] = useState<any>(undefined);
  const [budgetsEditModal, setBudgetsEditModal] = useState(false);
  const [budgetsEditMonth, setBudgetsEditMonth] = useState<any>(undefined);

  const getGoalsFromDateProjUser = (userId: number, societeId: any, month: number, year: number) => {
    let res: any = goals.find(e => e.comId === userId && e.societeId === societeId && e.month === month && e.year === year);
    if(!res)
      res = goal_societe_defaults.find(e => e.societeId === societeId && e.month === month && e.year === year)
    
    return res
  }

  const getGoalsFromDate = (month: number, year: number) => {
    if(goalsEditUser && societeValue && societeValue?.id !== "ALL")
      return getGoalsFromDateProjUser(goalsEditUser.id, societeValue.id, month, year)
    return undefined
  }

  const getBudgetsFromDate = (month: number, year: number) => {
    if(societeValue && societeValue?.id !== "ALL")
      return budgets.find(e => e.societeId === societeValue.id && e.month === month && e.year === year)
    return undefined
  }

  const months = constants.DP_MONTHS.map((e, i) => ({
    Header: e,
    accessor: String(i + 1),
    disableSortBy: true,
    disableFilters: true,
    // Cell: ({ value }) => value?.goalV || "-",
    Cell: ({ value, row: {original} }) => <div className="monthCardContent" style={{minWidth: "150px"}}>
      <div><b>Ventes :</b></div>
      <div>{value?.goalV ? `${value.goalV.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
      <div><b>Enc. Ventes :</b></div>
      <div>{value?.goalE ? `${value.goalE.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
      <div><b>Recouvrement :</b></div>
      <div>{value?.goalR ? `${value.goalR.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
      <div><b>Livraison :</b></div>
      <div>{value?.goalL ? `${value.goalL.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
      {!!value?.comment && <>
        <FontAwesomeIcon icon={faCommentDots} className="monthCardBtnIcon monthCardComment" data-tip data-for={`comment_tooltip_ob${i}`} />
        <ReactTooltip effect="solid" id={`comment_tooltip_ob${i}`} type={"dark"}>
          {value?.comment}
        </ReactTooltip>
      </>}
      {(!!original?.isBudget && societeValue?.id !== "ALL" && !!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_BUDGETS)) && <FontAwesomeIcon icon={faEdit} className="monthCardBtnIcon monthCardEdit" title="Modifier les objectifs budget de ce mois" onClick={() => {setBudgetsEditMonth({month: value?.month, year: value?.year}); setBudgetsEditModal(true);}} />}
      {(!!original?.isUser && !!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_GOALS)) && <FontAwesomeIcon icon={faEdit} className="monthCardBtnIcon monthCardEdit" title="Modifier les objectifs commercial de ce mois" onClick={() => {setGoalsEditMonth({month: value?.month, year: value?.year}); setGoalsEditUser(original.user); setGoalsEditModal(true);}} />}
      {!!value?.usersWithNoGoal?.length && <>
        <FontAwesomeIcon icon={faExclamationTriangle} className="monthCardBtnIcon monthCardNoGoals" data-tip data-for={`nogoal_tooltip_ob${i}`} />
        <ReactTooltip effect="solid" id={`nogoal_tooltip_ob${i}`} type={"dark"}>
          {value.usersWithNoGoal.length} commercial{value.usersWithNoGoal.length > 1 && "s"} sans objectif défini: <b>{value.usersWithNoGoal.map(e => e.LOGIN).join(", ")}</b>
        </ReactTooltip>
      </>}
      {!!value?.societesWithNoBudgets?.length && <>
        <FontAwesomeIcon icon={faExclamationTriangle} className="monthCardBtnIcon monthCardNoGoals" data-tip data-for={`nobudget_tooltip_ob${i}`} />
        <ReactTooltip effect="solid" id={`nobudget_tooltip_ob${i}`} type={"dark"}>
          {value.societesWithNoBudgets.length} projet{value.societesWithNoBudgets.length > 1 && "s"} sans budget défini: <b>{value.societesWithNoBudgets.map(e => e.LIBELE).join(", ")}</b>
        </ReactTooltip>
      </>}
      {!!value?.societesWithUsersWithNoGoal?.length && <>
        <FontAwesomeIcon icon={faExclamationTriangle} className="monthCardBtnIcon monthCardNoGoals" data-tip data-for={`nogoalgroupe_tooltip_ob${i}`} />
        <ReactTooltip effect="solid" id={`nogoalgroupe_tooltip_ob${i}`} type={"dark"}>
          {value.societesWithUsersWithNoGoal.length} projet{value.societesWithUsersWithNoGoal.length > 1 && "s"} avec des commerciaux sans objectif défini: <b>{value.societesWithUsersWithNoGoal.map(e => e.LIBELE).join(", ")}</b>
        </ReactTooltip>
      </>}
    </div>
  }))

  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "name",
        className: "tableLeftHeader",
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ value, row: {original} }) => <div style={{...(!!original?.isUser && {fontWeight: "normal", textDecoration: "underline"})}}>{value}{!!original.showHideUsers && <>&nbsp;<FontAwesomeIcon icon={showUsers ? faEyeSlash : faEye} /*className={`flipIcon${showUsers ? " flipped" : ""}`}*/ style={{cursor: "pointer"}} onClick={() => setShowUsers(e => !e)} title="Afficher/Masquer les objectifs des commerciaux" /></>}</div>
      },
      ...months
    ],
    [showUsers]
  );

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} showPagination={false} enableCheckBox={false} isEditable={false} centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <GoalEdit modal={goalsEditModal} setModal={setGoalsEditModal} modalData={goalsEditMonth} selectedUserGoal={goalsEditUser} societeGoal={societeValue} getGoalsFromDate={getGoalsFromDate} />
      <BudgetEdit modal={budgetsEditModal} setModal={setBudgetsEditModal} modalData={budgetsEditMonth} societeGoal={societeValue} getBudgetsFromDate={getBudgetsFromDate} />
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(GoalTable);
